import { log } from '@/log'
import Cookies from 'js-cookie'

export class SessionCookie {

  sessionCookieExists(): boolean {
    const sessionCookie = Cookies.get('mc_s')

    return !!sessionCookie
  }

  /**
   * JWTのpayload部分をパースして返す
   * API呼び出しによってserver側で必ず検証が行われるため、client側での署名の検証は行わない
   */
  readPayload(): SessionCookiePayload | null {
    const sessionCookie = Cookies.get('mc_s')
    if (!sessionCookie) {
      return null
    }

    const payload = sessionCookie.split('.')[1]
    if (!payload) {
      return null
    }

    try {
      const decodedPayload = JSON.parse(atob(payload))

      if (
        typeof decodedPayload.id !== 'string'
        || typeof decodedPayload.v !== 'number'
        || typeof decodedPayload.startAt !== 'number'
        || typeof decodedPayload.data !== 'object'
      ) {
        log.error('Invalid session cookie payload', decodedPayload)

        return null
      }

      return {
        id: decodedPayload.id,
        v: decodedPayload.v,
        startAt: decodedPayload.startAt,
        data: decodedPayload.data,
      }
    } catch (error) {
      log.error(error)

      return null
    }
  }

  /**
   * セッションクッキーを削除する
   */
  clear(): void {
    Cookies.remove('mc_s')
  }
}

export interface SessionCookiePayload {
  id: string
  v: number
  startAt: number
  data: any // TODO: u, sに相当する情報を入れるようにする
}
